export default __webpack_public_path__ + "static/media/ico_checkbox_empty_blue.ec608e8a.svg";